import React, { useState } from "react";
import {
    Box,
    Flex,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Badge,
    Button,
    Input,
    InputGroup,
    InputRightAddon,
    Icon,
    TableContainer,
    VStack,
    HStack,
    SimpleGrid,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { FiMonitor } from "react-icons/fi";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const PAGE_SIZE = 10;

const betsData = [
    { id: "FPIFH39K", date: "2025-11-20 11:32 AM", user: "@bettaprop", type: "Single", stake: 100.0, return: 235.0, status: "Won" },
    { id: "676O2BBD", date: "2025-11-19 07:47 AM", user: "@5800900", type: "Single", stake: 100.0, return: 210.0, status: "Won" },
    { id: "7XM8RXLZ", date: "2025-11-18 03:58 AM", user: "@5800900", type: "Single", stake: 23.0, return: 38.41, status: "Won" },
];

const WonBets = () => {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");

    const filtered = betsData.filter((b) =>
        b.id.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    const start = (page - 1) * PAGE_SIZE;
    const data = filtered.slice(start, start + PAGE_SIZE);
    const SIDEBAR_WIDTH = "240px";

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={8}
                bg="gray.50"
                minH="100vh"
                mt="64px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                <Flex
                    mb={8}
                    justify="space-between"
                    align={{ base: "stretch", md: "center" }}
                    direction={{ base: "column", md: "row" }}
                    gap={3}
                >
                    <Text fontSize="2xl" fontWeight="semibold" color="#1a202c">
                        Won Bets
                    </Text>

                    <InputGroup maxW={{ base: "100%", md: "300px" }} size="md">
                        <Input
                            bg="white"
                            placeholder="Bet ID"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            borderRight="none"
                            _focus={{ borderColor: "#4c1d95", boxShadow: "none" }}
                        />
                        <InputRightAddon bg="#4f46e5" cursor="pointer">
                            <Icon as={SearchIcon} color="white" />
                        </InputRightAddon>
                    </InputGroup>
                </Flex>

                <Box bg="white" borderRadius="lg" overflow="hidden" boxShadow="sm" border="1px solid #e2e8f0" display={{ base: "none", md: "block" }}>
                    <TableContainer>
                        <Table variant="simple">
                            <Thead bg="#4f46e5">
                                <Tr h="50px">
                                    <Th color="white" textTransform="none" borderTopLeftRadius="lg">Bet ID</Th>
                                    <Th color="white" textTransform="none">Bet Placed At</Th>
                                    <Th color="white" textTransform="none">User</Th>
                                    <Th color="white" textTransform="none">Type</Th>
                                    <Th color="white" textTransform="none">Stake Amount</Th>
                                    <Th color="white" textTransform="none">Return</Th>
                                    <Th color="white" textTransform="none">Status</Th>
                                    <Th color="white" textTransform="none" borderTopRightRadius="lg">Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.map((b) => (
                                    <Tr key={b.id} _hover={{ bg: "gray.50" }}>
                                        <Td fontSize="sm">{b.id}</Td>
                                        <Td fontSize="sm">{b.date}</Td>
                                        <Td fontSize="sm" color="#3182ce">{b.user}</Td>
                                        <Td>
                                            <Badge variant="outline" rounded="full" px={3} colorScheme={b.type === "Single" ? "green" : "purple"}>
                                                {b.type}
                                            </Badge>
                                        </Td>
                                        <Td fontSize="sm" fontWeight="semibold">${b.stake.toFixed(2)}</Td>
                                        <Td fontSize="sm" fontWeight="semibold">${b.return.toFixed(2)}</Td>
                                        <Td>
                                            <Badge variant="solid" colorScheme="green" rounded="full" px={3}>
                                                Won
                                            </Badge>
                                        </Td>
                                        <Td>
                                            <Button size="sm" variant="outline" colorScheme="blue" leftIcon={<Icon as={FiMonitor} />}>
                                                Detail
                                            </Button>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>

                {/* Mobile View */}
                <VStack display={{ base: "flex", md: "none" }} spacing={4} align="stretch">
                    {data.map((b) => (
                        <Box key={b.id} bg="white" p={4} borderRadius="lg" boxShadow="sm" border="1px solid" borderColor="gray.200">
                            <Flex justify="space-between" align="center" mb={3}>
                                <Text fontWeight="bold" fontSize="md">#{b.id}</Text>
                                <Badge variant="solid" colorScheme="green" rounded="full" px={3}>
                                    Won
                                </Badge>
                            </Flex>

                            <SimpleGrid columns={2} spacing={4} mb={4}>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">User</Text>
                                    <Text fontSize="sm" fontWeight="500" color="blue.500">{b.user}</Text>
                                </Box>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Date</Text>
                                    <Text fontSize="sm" fontWeight="500">{b.date}</Text>
                                </Box>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Type</Text>
                                    <Badge variant="outline" colorScheme={b.type === "Single" ? "green" : "purple"} fontSize="xs" mt={1}>
                                        {b.type}
                                    </Badge>
                                </Box>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Stake</Text>
                                    <Text fontSize="sm" fontWeight="bold">${b.stake.toFixed(2)}</Text>
                                </Box>
                            </SimpleGrid>

                            <Flex justify="space-between" align="center" pt={3} borderTop="1px solid" borderColor="gray.100">
                                <Box>
                                    <Text fontSize="xs" color="gray.500">Return</Text>
                                    <Text fontSize="md" fontWeight="bold" color="green.600">${b.return.toFixed(2)}</Text>
                                </Box>
                                <Button size="sm" variant="outline" colorScheme="blue" leftIcon={<Icon as={FiMonitor} />}>
                                    Detail
                                </Button>
                            </Flex>
                        </Box>
                    ))}
                </VStack>
            </Box>
        </>
    );
};

export default WonBets;
